import { isMobile } from 'mobile-device-detect'

export default function() {
    return {
        showForm: false,
        isMobile,
        idUser: null,
        user: {
            name: null,
            password: null,
            rg: null,
            gender: null,
            phone: null,
            birthDate: null,
            contactName: null,
            contactPhone: null,
            email: null
        },
        error: {
            name: null,
            password: null,
            rg: null,
            gender: null,
            phone: null,
            birthDate: null,
            contactName: null,
            contactPhone: null,
        },
        success: false,
        errorCode: null,
        errorMessage: null,
        invalidData: 'Verifique os campos e tente novamente.',
        serverError: 'Ocorreu um erro, por favor tente novamente mais tarde.',
        availableGenders: [
            {
                value: null,
                label: 'Selecionar'
            },
            {
                value: 'F',
                label: 'Feminino'
            },
            {
                value: 'M',
                label: 'Masculino'
            },
            {
                value: 'O',
                label: 'Outros'
            }
        ],
        ufList: [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'DF',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO'
        ],
        datePickerConfig: {
            nextMonthCaption: 'Próximo mês',
            prevMonthCaption: 'Mês anterior',
            weekdays: [
                'S', 'T', 'Q', 'Q', 'S', 'S', 'D'
            ],
            months: [
                'Janeiro', 'Fevereiro', 'Março', 'Abril',
                'Maio', 'Junho', 'Julho', 'Agosto',
                'Setembro', 'Outubro', 'Novembro', 'Dezembro'
            ]
        },
        errorResponse: '',
        successResponse: '',
        password: null,
        passwordConfirmation: null,
        baseUrl: process.env.VUE_APP_BASE_URL
    }
}
